<template>
  <div class="form-box" :class="{ 'formbox-other': otherLogin }" @click.stop>
    <div class="type-title" v-if="!otherLogin && !findPassword">
      <span :class="{ current: codeLogin }" @click="
        codeLogin = true;
      resetForm('loginInfo');
      ">
        验证码登录
      </span>
      <span :class="{ current: !codeLogin }" @click="
        codeLogin = false;
      resetForm('loginInfo');
      ">
        密码登录
      </span>
    </div>
    <div class="type-title type-title-forget" v-if="findPassword">
      <span class="primary-color">忘记密码</span>
    </div>
    <div class="type-title type-title-other" v-if="otherLogin">
      <span class="primary-color">绑定手机号</span>
    </div>
    <el-form class="form-code-password-login" :class="{ 'form-code-login': codeLogin }"
      v-show="!otherLogin && !findPassword" :model="loginInfo" :rules="rules" ref="loginInfo"
      :hide-required-asterisk="true" :validate-on-rule-change="false">
      <el-form-item prop="phone" class="phone">
        <div class="label">手机号</div>
        <el-input placeholder="请输入手机号" v-model="loginInfo.phone" @focus="onInputFocus" @blur="onInputBlur"
          maxlength="11">
          <template slot="prepend">+86</template>
        </el-input>
      </el-form-item>
      <el-form-item prop="code" v-if="codeLogin" class="el-form-item-code">
        <div class="label">验证码</div>
        <el-input placeholder="请输入验证码" v-model="loginInfo.code" @keydown.native.enter="submitForm()"
          @focus="onInputFocus" @blur="onInputBlur"></el-input>
        <el-button class="btn-code" :disabled="codeBtn" type="text"
          @click="get_code('loginInfo', 'login', loginInfo.phone)">
          {{ codeBtnInfo }}
        </el-button>
      </el-form-item>

      <el-form-item prop="password" class="el-form-item-password" v-if="!codeLogin">
        <div class="label">密码</div>
        <el-password v-model="loginInfo.password" @enter="submitForm()"></el-password>
        <el-button class="btn-forget" type="text" v-if="!codeLogin" @click="forget_password">
          忘记密码?
        </el-button>
      </el-form-item>
      <el-form-item v-if="pcLoginCount > 3" prop="captcha" class="code el-form-item__img-code">
        <el-input placeholder="请输入图形验证码" v-model="loginInfo.captcha" @keydown.native.enter="submitForm()"
          @focus="onInputFocus" @blur="onInputBlur" maxlength="6"></el-input>
        <img :src="img_code" class="img_code" @click="getImgCode" title="点击切换验证码" />
        <img class="img-refresh" src="@/assets/images/common/refresh@2x.png" @click="getImgCode" />
        <a class="lnk-refresh" @click="getImgCode">刷新</a>
      </el-form-item>
      <div v-if="
        codeLogin && $store.state.commonSetting.allow_student_register == 1
      " class="code-login-tip">
        未注册的手机号登录时将自动注册
      </div>
      <el-form-item class="submit">
        <div class="btn-login" @click="submitForm()">登录</div>
      </el-form-item>
    </el-form>
    <el-form v-if="otherLogin" :model="otherLoginInfo" :rules="otherLoginRules" ref="otherLoginInfo" class="other-login"
      :hide-required-asterisk="true" :validate-on-rule-change="false">
      <div class="other-login-tip">
        请绑定手机号，便于后续给您发送上课提醒短信，以免错过课程
      </div>
      <el-form-item prop="phone" class="phone">
        <div class="label">手机号</div>
        <el-input placeholder="请输入手机号" v-model="otherLoginInfo.phone" @focus="onInputFocus" @blur="onInputBlur"
          maxlength="11">
          <template slot="prepend">+86</template>
        </el-input>
      </el-form-item>
      <el-form-item class="el-form-item-code" prop="code">
        <div class="label">验证码</div>
        <el-input placeholder="请输入验证码" v-model="otherLoginInfo.code" @focus="onInputFocus" @blur="onInputBlur">
        </el-input>
        <el-button class="btn-code" :disabled="codeBtn" type="text" @click="
          get_code('otherLoginInfo', 'loginOauth', otherLoginInfo.phone)
        ">
          {{ codeBtnInfo }}
        </el-button>
      </el-form-item>
      <el-form-item class="submit">
        <div class="btn-login" @click="otherSubmitForm()">确定</div>
      </el-form-item>
    </el-form>
    <el-form v-show="findPassword" :model="otherLoginInfo" :rules="otherLoginRules" ref="findPasswordInfo"
      :hide-required-asterisk="true" class="find-password" :validate-on-rule-change="false">
      <el-form-item prop="phone" class="phone">
        <div class="label">手机号</div>
        <el-input placeholder="请输入手机号" v-model="otherLoginInfo.phone" @focus="onInputFocus" @blur="onInputBlur">
          <template slot="prepend">+86</template>
        </el-input>
      </el-form-item>
      <el-form-item prop="code">
        <div class="label">验证码</div>
        <el-input placeholder="请输入验证码" v-model="otherLoginInfo.code" @focus="onInputFocus" @blur="onInputBlur">
        </el-input>
        <el-button class="btn-code" :disabled="codeBtn" type="text" @click="
          get_code('findPasswordInfo', 'getPassword', otherLoginInfo.phone)
        ">
          {{ codeBtnInfo }}
        </el-button>
      </el-form-item>
      <el-form-item class="el-form-item-password" prop="password">
        <div class="label">密码</div>
        <el-password v-model="otherLoginInfo.password"></el-password>
      </el-form-item>
      <div class="btn-login" @click="findSubmitForm()">确定</div>
      <div class="now-login" @click="nowLogin">登录</div>
    </el-form>
    <div class="other" v-if="!findPassword && !otherLogin">
      <div class="title" v-if="
        oauthConfig.wxLogin.is_available == 1 ||
        oauthConfig.qqLogin.is_available == 1
      ">
        第三方登录
      </div>
      <div class="set">
        <img src="@/assets/images/login/wechat@2x.png" class="wechat" @click="wx_login()"
          v-if="oauthConfig.wxLogin.is_available == 1" />
        <img src="@/assets/images/login/qq@2x.png" class="qq" @click="qq_login()"
          v-if="oauthConfig.qqLogin.is_available == 1" />
      </div>
      <div class="center contract">
        <span>登录即代表您同意</span>
        <a href="javascript:void(0)" @click="openContract('user_register_contract')">
          《用户注册协议》
        </a>
        <span>和</span>
        <a href="javascript:void(0)" @click="openContract('user_protect_contract')">
          《隐私政策》
        </a>
      </div>
    </div>
    <SelectSchoolDlg ref="selectSchool" :visible.sync="showSelectSchool" @on-select="onSelectSchool"></SelectSchoolDlg>
  </div>
</template>
<script>
import SelectSchoolDlg from "./SelectSchoolDlg";
export default {
  name: "StudentLogin",
  components: {
    SelectSchoolDlg,
  },
  data() {
    let validatePhone = (rule, value, callback) => {
      let reg = /^1\d{10}$/;
      if (value === "") {
        callback(new Error("请输入手机号码"));
      } else if (value.length < 11) {
        callback(new Error("手机号码不足11位，请重新输入！"));
      } else if (reg.test(value) === false) {
        callback(new Error("请输入正确的11位号码！"));
      } else {
        callback();
      }
    };
    let imgCode = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("图形验证码不能为空"));
      } else if (value.length < 4) {
        callback(new Error("图形验证码不足4位，请重新输入！"));
      } else {
        callback();
      }
    };
    let validateCode = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入短信验证码"));
      } else if (value.length < 6) {
        callback(new Error("短信验证码不足6位，请重新输入！"));
      } else {
        callback();
      }
    };
    let validateRePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (this.passInfo.rePassword !== this.passInfo.password) {
        callback(new Error("两次输入密码不一致"));
      } else if (this.$pub.guarantee(1, this.passInfo.rePassword)) {
        if (this.$pub.guarantee(1, this.passInfo.rePassword) == true) {
          callback();
        } else {
          callback(new Error(this.$pub.guarantee(1, this.passInfo.rePassword)));
        }
      } else {
        callback();
      }
    };
    let RecoverPassword = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (this.$pub.guarantee(1, value)) {
        if (this.$pub.guarantee(1, value) == true) {
          callback();
        } else {
          callback(new Error(this.$pub.guarantee(1, value)));
        }
      } else {
        callback();
      }
    };
    return {
      pcLoginCount: 0,
      img_code: "",
      codeBtn: false,
      codeBtnInfo: "获取验证码",
      codeLogin: false,
      otherLogin: false,
      findPassword: false,
      loginInfo: {
        phone: "",
        password: "",
        code: "",
        captcha: "",
        key: "",
      },
      rules: {
        phone: [
          {
            required: true,
            validator: validatePhone,
            trigger: "blur",
          },
        ],
        captcha: [
          {
            required: true,
            validator: imgCode,
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
          {
            min: 6,
            max: 16,
            message: "密码长度在 6 到 16 个字符",
            trigger: "blur",
          },
        ],
        code: [
          {
            required: true,
            validator: validateCode,
            trigger: "blur",
          },
        ],
      },
      passInfo: {
        password: "",
        rePassword: "",
      },
      passRules: {
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
          {
            min: 6,
            max: 16,
            message: "密码长度在 6 到 16 个字符",
            trigger: "blur",
          },
        ],
        rePassword: [
          {
            required: true,
            validator: validateRePass,
            trigger: "blur",
          },
        ],
      },
      otherLoginInfo: {
        phone: "",
        code: "",
        password: "",
      },
      otherLoginRules: {
        phone: [
          {
            required: true,
            validator: validatePhone,
            trigger: "blur",
          },
        ],
        captcha: [
          {
            required: true,
            validator: imgCode,
            trigger: "blur",
          },
        ],
        code: [
          {
            required: true,
            validator: validateCode,
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            validator: RecoverPassword,
            trigger: "blur",
          },
        ],
      },
      access_token: "",
      wx_openid: "",
      wx_unionid: "",
      openId: "",
      otherType: 1,
      oauthConfig: { qqLogin: {}, wxLogin: {} },
      showSelectSchool: false,
    };
  },
  watch: {
    $route: {
      handler: function () {
        this.pcLoginCount = sessionStorage.pcLoginCount;
        if (sessionStorage.pcLoginCount > 3) {
          this.getImgCode();
        }
      },
      // 深度观察监听
      deep: true,
    },
  },
  async created() {
    this.pcLoginCount = sessionStorage.pcLoginCount;
    if (sessionStorage.pcLoginCount > 3) {
      this.getImgCode();
    }
    this.oauthConfig = await this.$http.get(
      "/api/app/systemSet/available/oauthConfig",
    );
    if (this.$route.query.code) {
      this.otherType = this.$route.query.state;
      let data = await this.$http.post("/api/app/login", {
        type: this.otherType,
        code: this.$route.query.code,
      });
      if (data.need_collect_data) {
        sessionStorage.setItem("pr_webToken", data.remember_token);
        this.$router.push({
          name: "RegistInformation",
        });
        return;
      }
      if (data.id) {
        this.$store.commit("login", data.remember_token);
        await this.$store.dispatch("get_user_info");
        this.goTo();
      }
      else if (data.wx_openid) {
        this.access_token = data.access_token;
        this.wx_openid = data.wx_openid;
        this.wx_unionid = data.wx_unionid;
        this.otherLogin = true;
      } else {
        this.openId = data.msg;
        this.otherLogin = true;
      }
    }
  },
  mounted: function () {
    if (this.$route.query.type == "register") {
      this.set_login_type();
    }
    this.$nextTick(() => {
      document.getElementById("app").style.height = "100%";
    });
  },
  methods: {
    onSelectSchool(school_id) {
      this.$store.commit("clearSchoolInfo");
      this.$store.commit("setSchoolID", school_id);
      if (this.otherLogin) {
        this.otherLoginFunc();
      } else {
        this.login();
      }
    },
    getImgCode() {
      let that = this;
      that.$http
        .get("/api/app/captcha", {})
        .then(res => {
          that.img_code = res.img;
          that.loginInfo.key = res.key;
        })
        .catch(err => {
          console.log(err);
        });
    },
    onInputFocus($event) {
      let target = $event.target;
      target.parentElement.classList.add("focus");
    },
    onInputBlur($event) {
      let target = $event.target;
      target.parentElement.classList.remove("focus");
    },
    goTo() {
      this.$store.dispatch("refreshMessageState");
      if (this.$route.query.relogin) {
        this.$router.go(-1);
      } else {
        this.$router.push({ name: "Home" });
      }
    },
    submitForm() {
      this.$refs["loginInfo"].validate(async valid => {
        if (!valid) return;
        // 密码登陆不检测用户
        if (!this.codeLogin) {
          await this.login();
        } else {
          const result = await this.checkUser(this.loginInfo.phone);
          if (result.is_new_user == 1) {
            if (this.$refs.selectSchool.isSingleSchool()) {
              this.onSelectSchool(this.$refs.selectSchool.getSingleSchoolID());
            } else {
              this.showSelectSchool = true;
            }
          } else {
            await this.login();
          }
        }
      });
    },
    set_login_type() {
      this.codeLogin = !this.codeLogin;
      this.resetForm("loginInfo");
      this.loginInfo.password = "";
      this.loginInfo.code = "";
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    async checkUser(mobile) {
      const data = await this.$http.get(`/api/app/checkUser/${mobile}`);
      return data;
    },
    async login() {
      let request = {
        mobile: this.loginInfo.phone,
        type: this.codeLogin ? 2 : 1,
        client: 1,
      };
      if (this.codeLogin) {
        request.sms_code = this.loginInfo.code;
      } else {
        request.password = this.loginInfo.password;
      }
      if (!sessionStorage.pcLoginCount) {
        sessionStorage.pcLoginCount = 0;
      }
      sessionStorage.pcLoginCount++;
      this.pcLoginCount = sessionStorage.pcLoginCount;
      if (sessionStorage.pcLoginCount > 3) {
        this.getImgCode();
        request.captcha = this.loginInfo.captcha;
        request.key = this.loginInfo.key;
      }
      let data = await this.$http.post("/api/app/login", request);
      sessionStorage.removeItem("pcLoginCount");
      if (data.need_collect_data) {
        sessionStorage.setItem("pr_userId", data.id);
        sessionStorage.setItem("pr_webToken", data.remember_token);
        this.$router.push({
          name: "RegistInformation",
        });
      } else {
        this.$store.commit("login", data.remember_token);
        await this.$store.dispatch("get_user_info");
        await this.$success("登录成功");
        this.goTo();
      }
    },
    get_code(info, type, mobile) {
      this.$refs[info].validateField("phone", async validMessage => {
        if (validMessage != "") {
          return;
        }
        await this.$services.CodeService.sendSmsCode(mobile, type);
        let count = 60;
        this.codeBtn = true;
        let sendTimer = setInterval(() => {
          count--;
          this.codeBtnInfo = "重新发送" + count;
          if (count < 0) {
            this.codeBtn = false;
            clearInterval(sendTimer);
            this.codeBtnInfo = "获取验证码";
          }
        }, 1000);
      });
    },
    forget_password() {
      this.findPassword = true;
      this.resetForm("findPasswordInfo");
    },
    nowLogin() {
      this.findPassword = false;
      this.resetForm("loginInfo");
    },
    qq_login() {
      let url = location.protocol + "//" + location.host;
      document.location =
        "https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=" +
        this.oauthConfig.qqLogin.appId +
        "&redirect_uri=" +
        url +
        "/login&state=3";
    },
    wx_login() {
      let url = location.protocol + "//" + location.host;
      document.location =
        "https://open.weixin.qq.com/connect/qrconnect?appid=" +
        this.oauthConfig.wxLogin.appId +
        "&redirect_uri=" +
        url +
        "/login&response_type=code&scope=snsapi_login&state=4#wechat_redirect";
    },
    otherSubmitForm() {
      this.$refs["otherLoginInfo"].validate(async valid => {
        if (!valid) return;
        const result = await this.checkUser(this.otherLoginInfo.phone);
        if (result.is_new_user == 1) {
          if (this.$refs.selectSchool.isSingleSchool()) {
            this.onSelectSchool(this.$refs.selectSchool.getSingleSchoolID());
          } else {
            this.showSelectSchool = true;
          }
        } else {
          await this.otherLoginFunc();
        }
      });
    },
    async otherLoginFunc() {
      let parameters = {
        type: this.$route.query.state,
        mobile: this.otherLoginInfo.phone,
        sms_code: this.otherLoginInfo.code,
        password: this.otherLoginInfo.password,
      };
      if (this.wx_openid) {
        parameters.openid = this.wx_openid;
        parameters.unionid = this.wx_unionid;
        parameters.access_token = this.access_token;
      }
      else
      {
        parameters.unionid = this.openId;
      }
      let data = await this.$http.post("/api/app/login", parameters);
      sessionStorage.removeItem("pcLoginCount");
      if (data.need_collect_data) {
        sessionStorage.setItem("pr_webToken", data.remember_token);
        this.$router.push({
          name: "RegistInformation",
        });
      } else {
        this.$store.commit("login", data.remember_token);
        await this.$store.dispatch("get_user_info");
        await this.$success("登录成功");
        this.goTo();
      }
    },
    findSubmitForm() {
      this.$refs["findPasswordInfo"].validate(async valid => {
        if (!valid) {
          return;
        }
        await this.$http.post("/api/app/password", {
          mobile: this.otherLoginInfo.phone,
          password: this.otherLoginInfo.password,
          sms_code: this.otherLoginInfo.code,
        });
        await this.$info("密码重置成功，请登录！");
        this.findPassword = false;
      });
    },
    openContract(key) {
      const { href } = this.$router.resolve({
        name: "Contract",
        query: {
          key: key,
        },
      });
      document.location = href;
    },
  },
};
</script>

<style scoped lang="scss">
@import "../css/login.scss";
</style>
